import { writable } from 'svelte/store';
import { login } from '../../app.logic';
import { AuthService } from "../../services/auth.service";
export const loginErrors = writable([]);
export async function doLogin(username, password) {
    loginErrors.set([]);
    // console.log(`login: username: [${username}] password: [${password}]`);
    let loginDto = { email: username, password: password };
    try {
        let _resp = await AuthService.login(loginDto);
        // console.log("auth user dto", _resp.payload);
        login(_resp.payload);
    }
    catch (err) {
        let issue = err;
        // console.log("login error", issue);
        if (issue.code === 'LOGIN_ERROR') {
            loginErrors.set(["Wrong login or password"]);
        }
        else {
            loginErrors.set([issue.message]);
        }
    }
}
